var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deductions"},[_c('div',{staticClass:"header"},[_vm._v("DRIVER DEDUCTIONS")]),_vm._v(" "),_c('div',{staticClass:"deductions-container"},[_c('div',{staticClass:"deduction-content"},[_c('deduction-list',{attrs:{"isMobile":_vm.isMobile}})],1)]),_vm._v(" "),_c('deduction-form'),_vm._v(" "),_c('deduction-delete')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1192e4d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProviderDeductions/index.vue
// module id = 1766
// module chunks = 0